import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { colourClasses } from "@/lib/colours";

export function Pill({ colour, children, dot = true, ...rest }) {
  if (children === null || children === undefined || children === "") return <span className="text-slate-300">—</span>;
  const c = colourClasses(colour);
  return (
    <span
      {...rest}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap ${c.bg} ${c.text} ${c.border}`}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />}
      {children}
    </span>
  );
}

const JOB_STATUS_COLOUR = {
  COMPLETE: "emerald", BOOKED: "blue", IN_PROGRESS: "sky", NOT_STARTED: "slate", "PRODUCTS ALLOCATED": "indigo",
  "HOT TUB ON CONTAINER": "teal", "AWAITING DEPOSIT": "amber", "CUSTOMER WILL CALL BACK!": "amber",
  VOIDED: "rose", CANCELLED: "rose", FAILED: "rose", REFUNDED: "orange",
};
const jobStatusColour = (v) => {
  const k = String(v).trim().toUpperCase();
  if (JOB_STATUS_COLOUR[k]) return JOB_STATUS_COLOUR[k];
  if (/CALLED|EMAIL|WHATS ?APP/.test(k)) return "purple";
  return "slate";
};

export function JobStatusBadge({ value, to, ...rest }) {
  if (!value) return <span className="text-slate-300">—</span>;
  const c = colourClasses(jobStatusColour(value));
  const cls = `inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold border whitespace-nowrap ${c.bg} ${c.text} ${c.border}`;
  const inner = <><span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />{value}</>;
  if (to) {
    return <Link to={to} onClick={(e) => e.stopPropagation()} title={`Show only ${value} jobs`} {...rest}
      className={`${cls} hover:ring-2 hover:ring-offset-1 hover:ring-current/20 transition-shadow cursor-pointer`}>{inner}</Link>;
  }
  return <span {...rest} className={cls}>{inner}</span>;
}

export function StatusFilterChip({ value, onClear }) {
  if (!value) return null;
  return (
    <span className="inline-flex items-center gap-1.5 h-9 pl-3 pr-1.5 rounded-full border border-indigo-200 bg-indigo-50 text-indigo-700 text-sm font-medium" data-testid="status-filter-chip">
      Status: {value}
      <button type="button" onClick={onClear} className="w-6 h-6 rounded-full hover:bg-indigo-100 flex items-center justify-center" title="Clear status filter" data-testid="status-filter-clear">
        <X className="w-3.5 h-3.5" />
      </button>
    </span>
  );
}

// Small numeric stock chip: green when > 0, muted when 0/empty.
export function StockChip({ value }) {
  const n = Number(value);
  const positive = !isNaN(n) && n > 0;
  const c = positive ? colourClasses("green") : colourClasses("grey");
  return (
    <span className={`inline-flex items-center justify-center min-w-[28px] px-1.5 py-0.5 rounded-md text-xs font-semibold ${c.bg} ${c.text}`}>
      {value ?? 0}
    </span>
  );
}
